<script setup>

    import { defineProps, defineModel } from 'vue'
    import ProductFinderOption from './ProductFinderOption.vue'

    const model = defineModel()

    const props = defineProps({
        question: String,
        name: String,
        options: Array
    })

</script>

<template>
    <div class="product-finder__options-group">
        <p class="product-finder__options-question">{{ question }}</p>
        <div class="product-finder__radio-list">
            <ProductFinderOption
                v-for="option in options"
                v-model="model"
                v-bind="option"
                :name="name"
            />
        </div>
    </div>
</template>
